module.exports = __webpack_public_path__ + "static/media/iot-application-04.36342b14.jpg";